/**
 * vue-sparklines v2.0.1
 * (c) 2022 tangzhen@me.com
 * @license MIT
 */

import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { defineComponent, h } from 'vue';
import { spotProps } from './props.js';
import './utils/uid.js';
import './constant.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Spot = defineComponent({
  name: "Spot",
  inheritAttrs: false,
  props: spotProps,
  setup: function setup() {
    var lastPoint = function lastPoint(points) {
      var pl = points.length;

      Math.sign = Math.sign || function (x) {
        return x > 0 ? 1 : -1;
      };

      return pl < 2 ? 0 : Math.sign(points[pl - 2].y - points[pl - 1].y);
    };

    return {
      lastPoint: lastPoint
    };
  },
  render: function render() {
    var _this = this;

    var points = this.points,
        spotStyles = this.spotStyles,
        spotProps$1 = this.spotProps;
    var pl = points.length;
    return h("g", function () {
      var items = [];
      spotProps.spotStyles && items.push(h("circle", {
        style: spotStyles,
        cx: points[0].x,
        cy: points[0].y,
        r: spotProps$1.size
      }));
      spotProps$1.spotColors && items.push(h("circle", {
        style: _objectSpread(_objectSpread({}, spotStyles), {}, {
          fill: spotProps$1.spotColors[_this.lastPoint(points)],
          fillOpacity: 1,
          strokeOpacity: 1
        }),
        cx: points[pl - 1].x,
        cy: points[pl - 1].y,
        r: spotProps$1.size
      }));
      return items;
    }());
  }
});

export { Spot as default };
//# sourceMappingURL=Spot.js.map
